module.exports = __webpack_public_path__ + "static/media/delivery_kanban_bottom.e218cfc9.jpg";